import { SupportTicketRequestData } from './support-ticket-request-data';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

export function sendSupportTicket(data: SupportTicketRequestData): Promise<boolean|string> {
    const hubApi = getHubApi();

    return hubApi.sendSupportMessage(window.app.deviceIdentifier, data)
        .then((response) => {
            if (response !== 1) {
                return 'Bad response';
            }

            return true;
        })
        .catch((error) => error.message);
}
